@use 'styles/mixins';

.Container {
  @include mixins.flex-align-center;

  margin-bottom: 0.6rem;
  padding: 1rem 0;

  background-color: transparent;

  @include mixins.FocusShadow;

  &_WithOutMargin {
    margin-bottom: 0;
  }

  &_Img {
    margin-right: 0.8rem;
  }
}
